import { Box, Skeleton, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  InsightsTemplate,
  TAB_OPTION_KEYS,
} from 'packages/borrowing-base/ui/InsightsTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import CapitalProviderContextProvider from 'packages/organization/hooks/CapitalProviderContextProvider';
import { InsightsFundingOverviewContainer } from 'packages/statements/ui/InsightsFundingOverviewContainer';

export const InsightsFundingOverviewRoute = () => {
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;

  return (
    <Box>
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load insights outstanding balance page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/');
          }
        }}
      >
        <CapitalProviderContextProvider renderLoading={<Skeleton />}>
          <InsightsTemplate selectedTab={TAB_OPTION_KEYS.fundingOverview}>
            <InsightsFundingOverviewContainer />
          </InsightsTemplate>
        </CapitalProviderContextProvider>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
